const VERSION_STATUS: boolean = window.location.hostname.search('localhost') === -1;
const BETA_VERSION: boolean = window.location.hostname.search('beta') === -1;
const ARK_VERSION: boolean = window.location.hostname.search('4rk') === -1;
const MOBILE_VERSION: boolean = window.location.hostname.search('192.168.1.85') === -1;

// export const BASE_SITE = 'https://panel.mahi20.4rk.ir/';
// export const BASE_SITE = VERSION_STATUS ? 'https://panel.mahi20.4rk.ir/' : 'http://localhost/sanam/';
// export const BASE_SITE = 'https://panel.mahi20.4rk.ir/';
export const BASE_SITE = 'https://sitag.ir/api/';
// const BASE_API = VERSION_STATUS ? 'api/v1/' : 'api/beta/';
const BASE_API = VERSION_STATUS && BETA_VERSION && ARK_VERSION && MOBILE_VERSION ? 'v1/' : 'v1_beta/';


export const LOGIN_OR_REGISTER_POST = BASE_API + 'users/login_or_register'; //mobile
export const RESEND_ACTIVATION_COD_POST = BASE_API + 'users/resend_activation_code'; //mobile
export const USERS_ACTIVATION_POST = BASE_API + 'users/activation'; //code
export const USERS_CHECK_REFERAL_POST = BASE_API + 'users/check_referal'; //code
export const GENERATE_BUY_CODE_POST = BASE_API + 'users/generate_buy_code'; //code
export const GENERATE_INSTALLMENTS_BARCODE_POST = BASE_API + 'users/generate_installments_barcode'; //code
export const USERS_LOGOUT_GET = BASE_API + 'users/logout'; //Authorization
export const USERS_CHECK_LOGIN_GET = BASE_API + 'users/check_login'; //Authorization
export const USERS_EDIT_PROFILE = BASE_API + 'users/edit_profile'; //fullname ,email ,Authorization,address_title,glat,glng
export const MAIN = BASE_API + 'main'; //platform
export const REQUEST_CREDIT_FOR_CASH_PURCHASE = BASE_API + 'users/request_credit_for_cash_purchase'; //platform
export const SHOP_DETAILS = BASE_API + 'shops/details'; //platform
export const SHOPS_POST = BASE_API + 'shops'; //cat
export const USER_WALLET_TRANS_POST = BASE_API + 'users/wallet_trans'; //offset
export const SHOP_SEARCH_POST = BASE_API + 'shops/search'; //search_text
export const SHOP_SEARCH_BRANCH_POST = BASE_API + 'shops/search_branch'; //search_text
// export const PAYMENT_CHARGE_WALLET = BASE_API + 'payment/charge_wallet';
export const PAYMENT_CHARGE_WALLET = BASE_SITE + BASE_API + 'payment/charge_wallet';
export const PAYMENT_CHARGE_WALLET_TEST = BASE_SITE + BASE_API + 'payment/charge_wallet_test';
export const WITHDRAW_REQUEST_POST = BASE_API + 'users/withdraw'; //amount,sheba
export const CONTACT_US = BASE_API + 'contact_us';//Authorization,mobile,name,comment,subject
export const TRANSFER_WALLET = BASE_API + 'users/transfer_wallet';//Authorization,mobile,name,comment,subject
export const UPLOAD_FACTOR = BASE_API + 'users/upload_factor';//
export const SHOP_BRANCHES_POST = BASE_API + 'shops/branches'; //Authorization










export const BASE_IMAGES = BASE_SITE + 'images/';

export const BASE_IMAGE_PRODUCT = BASE_IMAGES + 'products/';
export const BASE_IMAGE_SLIDER_BIG = BASE_IMAGES + 'web_sliders/big/';
export const BASE_IMAGE_SLIDER_SMALL = BASE_IMAGES + 'web_sliders/small/';
export const BASE_IMAGE_TOP_SLIDER = BASE_IMAGES + 'top_sliders/';
export const IMG_DISCOUNT_PUBLIC_URL_SERVER = BASE_IMAGES + 'discount/';
export const BASE_IMG_CATEGORY = BASE_IMAGES + 'categories/';
export const BASE_IMG_STORE_CATEGORY = BASE_IMAGES + 'store_categories/';
export const BASE_LOGO_COMPANY = BASE_IMAGES + 'organizations/';
export const BASE_IMAGE_RECIPES = BASE_IMAGES + 'recepies/';
export const BASE_IMAGE_CERTIFICATES = BASE_IMAGES + 'certificates/';

export const MAIN_FIXED = BASE_API + 'main/fixed_objects'; //platform

export const LOGIN_STAFF = BASE_API + 'users/personnel_login'; //mobile



export const USERS_PROFILE_GET = BASE_API + 'users/profile'; //Authorization
export const MORE_PRODUCTS_DETAILS_POST = BASE_API + 'products/details'; //category
export const USERS_TRANSACTIONS_POST = BASE_API + 'users/transactions';//offset
export const USERS_ORG_FACTORS_POST = BASE_API + 'users/org_factors';//offset
export const ORDERS_BASKET_POST = BASE_API + 'orders/basket';//basket_products
export const USERS_ADDRESS_GET = BASE_API + 'users/get_address';//Authorization
export const AREAS_VALIDATE_POINT_POST = BASE_API + 'areas/validate_points';//glat,glng
export const USERS_ADD_ADDRESS = BASE_API + 'users/add_address';//address,glat,glng
export const DELIVERIES_GET_DAY_TIMES_POST = BASE_API + 'deliveries/get_day_times';//basket_products,addressId
export const QUESTIONS_GET = BASE_API + 'questions';//store,Auth,...
export const FACTORS_PRE_POST = BASE_API + 'factors/pre';//store,Auth,...
export const ORDERS_REGISTER_POST = BASE_API + 'orders/register';//store,Auth,...
export const USERS_ORDERS_HISTORY_POST = BASE_API + 'users/orders_history';//offset
export const USERS_COMPLETE_REGISTRATION = BASE_API + 'users/complete_registration';//fullname,address_title,glat,glng
export const COMPLAINT_POST = BASE_API + 'complaint';//comment
export const SPECIAL_ORDERS_POST = BASE_API + 'orders/register_special';//comment
export const USERS_DELETE_ADDRESS_POST = BASE_API + 'users/delete_address';//Authorization,address_num
export const USERS_EDIT_ADDRESS_POST = BASE_API + 'users/edit_address';//Authorization,address_num,address,glng,glat
export const POLLS_REGISTER_POST = BASE_API + 'polls/register';//Authorization,order,rate,comment
export const ORDERS_DETAILS_POST = BASE_API + 'orders/details';//Authorization,order
export const ORDER_CANCEL_POST = BASE_API + 'orders/cancel';//Authorization,order
export const DISCOUNT_CODE_POST = BASE_API + 'discount_codes';//Authorization,code
export const CATEGORIES_GET = BASE_API + 'categories';
export const CATEGORIES_SUBS_POST = BASE_API + 'categories/subs';
export const STORES_POST = BASE_API + 'stores';
export const PRODUCTS_CATEGORY_GET = BASE_API + 'products/all';
export const PRODUCTS_SEARCH_RESULT_POST = BASE_API + 'products/search_result';
export const AREAS = BASE_API + 'areas';
export const GET_AFFILIATE_PRICE_GET = BASE_API + 'setting/get_affiliate_price';
export const GET_SHOPS = BASE_API + 'shops';



// export const PAYMENT_PAY = BASE_API + "payment/pay";
export const PAYMENT_PAY = "https://panel.mahi20.4rk.ir/" + BASE_API + "payment/pay";
export const PAYMENT_FACTOR = "https://panel.mahi20.4rk.ir/" + BASE_API + 'payment/factor';

